/**
 * 常量路由配置
 * 不需要权限，所有人可访问
 */

// 公开路由
export const publicRoutes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/landing/home.vue'),
    hidden: true,
    meta: { title: '官网首页', public: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
    meta: { public: true },
  },
  {
    path: '/super-admin-login',
    name: 'SuperAdminLogin',
    component: () => import('@/views/login/super-admin.vue'),
    hidden: true,
    meta: { public: true, title: '超级管理员登录' },
  },
  {
    path: '/401',
    name: 'Page401',
    component: () => import('@/views/error/401.vue'),
    hidden: true,
    meta: { public: true },
  },
  {
    path: '/404',
    name: 'Page404',
    component: () => import('@/views/error/404.vue'),
    hidden: true,
    meta: { public: true },
  },
]

// 404 兜底路由
export const notFoundRoute = {
  path: '*',
  redirect: '/404',
  hidden: true,
}
